export const discoverKeys = {
  browse: (signedIn: boolean) => ["discover", "browse", signedIn] as const,
  explore: ["discover", "explore"] as const,
};
